import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Alessandro Rossignoli
 * id C5512AAF-943C-4025-8FAB-F14D896F2C14
 * name alert-plus-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-plus-outline.svg
 * tags
 * - Alert / Error 
 */
export const AlertPlusOutlineIcon = createSvgIcon(<><path d="M11 15.5H13V17.5H11V15.5M14 19C14 18.86 14 18.73 14 18.6H5.4L12 7.3L16.11 14.44C16.62 14 17.2 13.65 17.84 13.41L12 3.3L2 20.6H14.22C14.08 20.09 14 19.56 14 19M13 10.5H11V14.5H13V10.5M19 15V18H16V20H19V23H21V20H24V18H21V15H19Z" /></>, 'AlertPlusOutlineIcon');
export default AlertPlusOutlineIcon